import { render, staticRenderFns } from "./LogoSettings.vue?vue&type=template&id=2e334cf8&scoped=true&"
import script from "./LogoSettings.vue?vue&type=script&lang=js&"
export * from "./LogoSettings.vue?vue&type=script&lang=js&"
import style0 from "./LogoSettings.vue?vue&type=style&index=0&id=2e334cf8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e334cf8",
  null
  
)

export default component.exports